import script from "./AttachmentUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentUpload.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentUpload.vue?vue&type=style&index=0&id=d5970b50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5970b50"]])

export default __exports__